<template>
  <el-card class="box-card main-card">
    <el-form class="search-form" ref="form" :model="searchForm">
      <el-form-item label="状态：" label-width="60px">
        <!-- <el-select v-model="searchForm.status"
                   @change="getUacCertification"
                   placeholder="请选择状态" style="width:120px"> -->
        <el-select
          v-model="searchForm.status"
          @change="searchFn"
          placeholder="请选择状态"
          style="width: 120px"
          clearable
        >
          <el-option
            v-for="item in statusList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业名称：" label-width="85px">
        <el-input v-model="searchForm.name" clearable placeholder="请输入企业名称" size="small"></el-input>
      </el-form-item>
      <el-form-item label="" label-width="85px">
        <el-button type="primary" size="small" @click="searchFn">查询</el-button>
      </el-form-item>
    </el-form>
    <template>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="certType" label="认证类型">
          <template slot-scope="scope">
            <span v-if="scope.row.certType == 0">身份证</span>
            <span v-else>营业执照</span>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">
            <span v-if="scope.row.certType == 0"
              >个人名称：{{ scope.row.name }}</span
            >
            <span v-else>公司名称：{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="LoginId">
          <template slot-scope="scope">
            <span >{{ scope.row.accountId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="代码" prop="certNo">
          <template slot-scope="scope">
            <span v-if="scope.row.certType == 0"
              >身份证号：{{ scope.row.certNo }}</span
            >
            <span v-else>企业信用机构代码：{{ scope.row.certNo }}</span>
          </template>
        </el-table-column>

        <el-table-column label="照片" prop="certNo">
          <template slot-scope="scope">
            <span v-if="scope.row.certType == 0"
              >身份正面：
              <el-image
                style="width: 100px; height: 60px"
                :src="scope.row.certFile1"
                :preview-src-list="[scope.row.certFile1, scope.row.certFile2]"
              >
              </el-image
              >身份反面：
              <el-image
                style="width: 100px; height: 60px"
                :src="scope.row.certFile2"
                :preview-src-list="[scope.row.certFile1, scope.row.certFile2]"
              >
              </el-image
            ></span>
            <span v-else
              >营业执照：
              <el-image
                style="width: 100px; height: 60px"
                :src="scope.row.certFile1"
                :preview-src-list="[scope.row.certFile1]"
              >
              </el-image
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" style="color:#E6A23C;">等待审核</span>
            <span v-if="scope.row.status == 2" style="color:#67C23A;">审核通过</span>
            <span v-if="scope.row.status == 9" style="color:#F56C6C;">审核驳回</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createDate | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updateDate | formatDate }}
          </template>
        </el-table-column>
        <el-table-column min-width="145px" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="success"
              @click="handleStatus(scope.row, '2')"
              :disabled="scope.row.status == 2"
            >
              通过
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="handleStatus(scope.row, '9')"
              :disabled="scope.row.status == 2||scope.row.status == 9"
            >
              驳回
            </el-button>
            <el-button
              size="small"
              :type="scope.row.partnerFlag == '0' ? 'success' : 'danger'"
              @click="becomePartner(scope.row, '2')"
              :disabled="scope.row.status != 2"
            >
              <span v-if="scope.row.partnerFlag == '0'">成为行业伙伴</span>
              <span v-else>取消行业伙伴</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <PageComponent ref="pageInfo"></PageComponent>
  </el-card>
</template>

<script>
import PageComponent from "@/components/pageInfo/PageComponent";
import { Message } from "element-ui";

export default {
  components: { PageComponent },
  data() {
    return {
      searchForm: {
        periodIndex: "",
      },
      statusList: [
        {
          key: 1,
          value: "待审核",
        },
        {
          key: 2,
          value: "审核通过",
        },
      ],
      tableData: [],
    };
  },
  beforeCreate() {},
  created() {},
  methods: {
    getUacCertification: function () {
      var params = {};
      params.page = this.$refs.pageInfo.currentPage;
      params.pageSize = 10;
      if (this.searchForm.status != "") {
        params.status = this.searchForm.status;
      }
      if (this.searchForm.name != "") {
        params.name = this.searchForm.name;
      }

      this.getRequest("/uacCert/getList", params).then((resp) => {
        if (resp.status == 200) {
          if (resp.data.code == 1000) {
            this.tableData = resp.data.result.records;
            this.$refs.pageInfo.outputPagenator(
              resp.data.result.total,
              resp.data.result.size
            );
          } else {
            Message.error(resp.data.message);
          }
        } else {
          console.error("error");
        }
      });
    },
    //切换状态搜索
    searchFn() {
      this.$router.push({ query: { page: 1 } });
      var params = {};
      params.page = 1;
      params.pageSize = 10;
      if (this.searchForm.status != "") {
        params.status = this.searchForm.status;
      }
      if (this.searchForm.name != "") {
        params.name = this.searchForm.name;
      }
      this.getRequest("/uacCert/getList", params).then((resp) => {
        if (resp.status == 200) {
          if (resp.data.code == 1000) {
            this.tableData = resp.data.result.records;
            this.$refs.pageInfo.outputPagenator(
              resp.data.result.total,
              resp.data.result.pageSize
            );
          } else {
            Message.error(resp.data.message);
          }
        } else {
          console.error("error");
        }
      });
    },
    handleStatus(row, status) {
      let text = status === '2'? '确认通过此条认证吗？': '确认驳回此条认证吗？';
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postRequestJson("/uacCert/adminReview", {
          id: row.id,
          userId: row.userId,
          status: status,
        }).then((resp) => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            this.getUacCertification();
            this.$message({ type: data.status, message: data.message });

          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: status === '2'? '已取消通过操作': '已取消驳回操作'
        });
      });

    },
    becomePartner(row){
        let params = {
          userId: row.userId,
          partnerFlag: row.partnerFlag === 1 ? 0 : 1,
        }
        this.postRequestJson("/uacUser/update", params).then(resp => {
          if (resp && resp.status == 200) {
            if(resp.data.code === 1000){
              this.$message.success({message: row.partnerFlag == 1 ? '取消行业伙伴成功!' : '成为行业伙伴成功!'});
              this.getUacCertification();
            }else {
              this.$message.error({message: resp.data.message});
            }

          }
        });
    }
  },
  mounted: function () {
    this.getUacCertification();
    this.$refs.pageInfo.initPagenator(this.getUacCertification, null);
  },
  beforeDestroy() {},
};
</script>

